<template>
  <section :id="`comp_id_${compProps.elementId}`">
    <div class="count-box" :style="`background-color: ${privateProps.backgroundColor};`" v-if="timeStamp > 0 && this.showCD">
      <p class="tips" :style="`color: ${privateProps.textColor};`">{{privateProps.activeText}}</p>
      <count-down
        :timeStamp="timeStamp"
        class="count-down"
        :itemStyle="`color: ${privateProps.countDownColor}; background-color: ${privateProps.countDownBackground}`"
        @onCDend="() => {
          this.showCD = false
          this.getCouponStatus()
        }"
      />
    </div>
    <ul class="coupon-list">
      <li
        v-for="(item, index) in couponList"
        :key="index"
        @click="clickItem(item)"
      >
        <img :src="getImgSrc(item)" class="couponItem" alt="" />
      </li>
    </ul>
  </section>
</template>
<script>

import request from '@/services/request'
import countDown from '@/components/countDown'
import tujialogin from '@/utils/tujialogin'
import tujiaRedirect from '@/utils/tujiaRedirect'
import { eventBus } from '@/utils'

export default {
  mixins: [tujialogin, tujiaRedirect],
  components: {
    countDown
  },
  data() {
    return {
      statusList: [],
      showCD: true,
      serviceTime: Date.now()
    }
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  computed: {
    privateProps() {
      if (this.compProps && this.compProps.mate && this.compProps && this.compProps.mate.privateProps) {
        return this.compProps.mate.privateProps
      } else {
        return {
          activeText: '距离本场开抢'
        }
      }
    },
    timeStamp() {
      const { startTime = 0 } = this.privateProps
      const dateNow = this.serviceTime || Date.now()
      if (typeof startTime !== 'number' || typeof dateNow !== 'number') {
        return 0
      }
      const from = new Date(dateNow)
      const to = new Date(startTime)

      const fromH = from.getHours()
      const frmoM = from.getMinutes()
      const fromS = from.getSeconds()

      const toH = to.getHours()
      const toM = to.getMinutes()
      const toS = to.getSeconds()

      const f = ((fromH * 60 + frmoM) * 60 + fromS) * 1000
      const t = ((toH * 60 + toM) * 60 + toS) * 1000

      const delta = t - f
      // const delta = Date.now() + 10000 - dateNow
      return isNaN(delta) || delta < 0 ? 0 : delta
    },
    couponList() {
      if (this.compProps && this.compProps.mate) {
        const status = {}
        const coupouList = this.compProps.mate.items

        this.statusList.forEach((item) => {
          status[item.id] = item.status
        })

        coupouList.forEach((i) => {
          i.status = status[i.activityId] ? status[i.activityId] : 1
        })
        return this.compProps.mate.items
      }
      return []
    }
  },
  beforeMount() {
    this.getCouponStatus()
  },
  mounted() {
    window.addEventListener('pageshow', this._onPageShow = () => {
      this.getCouponStatus()
    })
  },
  beforeDestroy() {
    window.removeEventListener('pageshow', this._onPageShow)
  },
  methods: {
    getCouponStatus() {
      const ids = this.couponList.map((i) => i.activityId)
      request.post('/feapi/bingo/h5/promotion/matter/status', {
        ids,
        queryType: 1
      }).then((res) => {
        // status: 0:未知、1:未开始、2：已开始、3：已结束、4：无库存、5：已购买
        if (res.ret && res.data) {
          this.statusList = res.data.statusList
          if (res.data.serviceTime) {
            this.$root.serviceTime = res.data.serviceTime
            this.serviceTime = res.data.serviceTime
            eventBus.$emit('timeCdEnd', this.serviceTime)
          }
          if (res.data.activityEnd === true) {
            this.showCD = false
          }
        }
      })
    },
    getImgSrc(item = {}) {
      const { status } = item
      let src = item.unactiveImg
      if (status === 1) {
        src = item.unactiveImg
      } else if (status === 2) {
        src = item.activeImg
      } else if (status === 3) {
        src = item.endImg
      } else if (status === 4) {
        src = item.emptyImg
      } else if (status === 5) {
        src = item.purchasedImg
      }

      return `${this.picHost}${src}`
    },
    async clickItem(item) {
      const {
        status,
        activeAppLink,
        activeWebLink,
        activeMpLink,
        unactiveAppLink,
        unactiveWebLink,
        unactiveMpLink
      } = item
      const isLogin = await this.isLogin()
      if (isLogin) {
        // 活动开始
        if (status === 2) {
          this.doRedirect({
            mpLink: activeMpLink,
            appLink: activeAppLink,
            activeLink: activeWebLink
          }, true)
        } else if (status === 5) {
          this.doRedirect({
            mpLink: unactiveMpLink,
            appLink: unactiveAppLink,
            activeLink: unactiveWebLink
          }, true)
        }
      } else {
        const platform = await this.getEnv()
        // 未登录
        // 活动开始
        if (status === 2) {
          let redirect = platform === 1 ? activeMpLink : (platform === 2 ? activeAppLink : activeWebLink)
          this.goLoginPage({ redirect })
        } else if (status === 5) {
          let redirect = platform === 1 ? unactiveMpLink : (platform === 2 ? unactiveAppLink : unactiveWebLink)
          this.goLoginPage({ redirect })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .count-box {
    padding: 0.7rem 15px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .tips {
      line-height: 1.36rem;
      color: #de5336;
      font-size: 13px;
      line-height: 22px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 600;
    }
    .count-down {
      flex-shrink: 0;
    }
  }
  .coupon-list {
    img {
      pointer-events: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
    }
    img.couponItem {
      display: block;
      object-fit: cover;
      width: 100%;
    }
  }
</style>
